import { Injectable } from '@angular/core';
var AlertConfig = (function () {
    function AlertConfig() {
        /** default alert type */
        this.type = 'warning';
        /** is alerts are dismissible by default */
        this.dismissible = false;
        /** default time before alert will dismiss */
        this.dismissOnTimeout = undefined;
    }
    AlertConfig.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    AlertConfig.ctorParameters = function () { return []; };
    return AlertConfig;
}());
export { AlertConfig };
//# sourceMappingURL=alert.config.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-bootstrap/alert/alert.config.js
// module id = ../../../../ngx-bootstrap/alert/alert.config.js
// module chunks = 7